import React from 'react';
import _isEqual from 'lodash/isEqual';

import { StickyButtons, UiKit } from 'components';
import { useRecommendationConfig } from '../hooks';

export default function RecommendationActions({
  routeFragementToDiscardOnCancel = ''
}) {
  const {
    mode,
    data,
    initialData,
    isProcessing = false,
    onReset,
    onConfirm = () => {}
  } = useRecommendationConfig();

  const isCreating = mode === 'CREATE';
  const isDataSame = _isEqual(initialData, data);
  const isSaveDisabled = !isCreating && isDataSame;
  const primaryButtonText = isCreating
    ? 'Create Recommendation'
    : 'Save Changes';

  return (
    <StickyButtons
      onConfirm={() => onConfirm()}
      data={data}
      initialData={initialData}
      isEditMode={!isCreating}
      isProcessing={isProcessing}
      routeFragementToDiscardOnCancel={routeFragementToDiscardOnCancel}
    >
      <UiKit.Button
        size="lg"
        variant="outline"
        onClick={onReset}
        disabled={isProcessing}
      >
        Reset
      </UiKit.Button>
      <UiKit.Button
        size="lg"
        onClick={() => onConfirm()}
        processing={isProcessing}
        disabled={isSaveDisabled}
      >
        {primaryButtonText}
      </UiKit.Button>
    </StickyButtons>
  );
}
